<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
    @click:outside="$emit('changeValue', false)"
    @keydown="$emit('changeValue', false)"
  >
    <v-card>
      <v-card-title class="headline">
        <slot name="title" />
      </v-card-title>
      <v-card-text>
        <slot name="body" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="$emit('changeValue', false)">Cancelar</v-btn>
        <v-btn color="green darken-1" @click="$emit('deleteTriggered')">Deletar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        required: true
      }
    },

    emits: ['changeValue', 'deleteTriggered'],

    data() {
      return {
        dialog: false
      };
    },

    watch: {
      showDialog(newValue) {
        this.dialog = newValue;
      }
    }
  };
</script>